import axiosInstance from "@lib/axios";
import { getToken, removeAuthTokens } from "@lib/utils";

export const logout = async (): Promise<void> => {
    const token = getToken("refresh_token");

    await axiosInstance.post("/auth/user/logout", { token });
    removeAuthTokens();
};
